import { isEmpty } from '../../util/util'
const dateRegex = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/

export const validateDateOnBlur = (setFn, dateType, date, inputRef, resetCustomCalender) => {
  console.log('customStartDate', date)
  if (!isEmpty(date) && !dateRegex?.test(date)) {
    setFn('')
    resetCustomCalender(`Please enter valid ${dateType}.`)
    setTimeout(() => inputRef.current.focus(), 0)
  }
}

export const oneMonthValidation = (fromDate: any, toDate: any) => {
  const diffTime: any = parseInt((toDate - fromDate) / (1000 * 60 * 60 * 24), 10)

  return diffTime <= 31
}

export const isLatestSixMonth = (date: any) => {
  const currentDate = new Date(Date.now())
  const lastSixMonthDate = new Date(new Date().setMonth(currentDate.getMonth() - 6))

  return new Date(date)?.getTime() >= lastSixMonthDate?.getTime()
}

export const fromDateLessThanToDate = (fromDate: Date, toDate: Date) => {
  return new Date(fromDate)?.getTime() <= new Date(toDate)?.getTime()
}

export const lessThanToday = (date: Date) => {
  return new Date(date)?.getTime() <= new Date(Date.now()).getTime()
}
